import {useEffect, useState, useRef} from "react";
import moment from "moment";
// import { LoadingTip } from "tea-component"
import RangePicker from '@/pages/home/components/RangePicker';
import SelectMultiple from "../SelectMultiple";
// import { getFilterOptions } from "@/pages/dashboard/services/datalab";

function ReportFilters(props) {
  const { onChange, filterValues, filters = [], dateGranularity, dashboardUuid, isEn } = props;
  
  // const [loading, setLoading] = useState(false)
  
  return (<div className='filters-wrap'>
    {
      filters.map((item, index) =>
        item?.type === 'date' ?
          (<div
            key={item.name + item.tableId}
            className='search-item search-item-date'
          >
            <RangePicker
              className="search-border"
              type={dateGranularity[item.name + item.tableId]} // 初始化选中的tab类型
              value={filterValues[item.name + item.tableId]?.map(time => moment(time))}
              typeList={[dateGranularity[item.name + item.tableId]]}
              language={isEn ? 'en' : 'cn'}
              showSelectType={false}
    
              onChange={(value: any) => {
                filterValues[item.name + item.tableId] = value?.map(time => time?.format("YYYY-MM-DD"));
                onChange({ ...filterValues });
              }} //当选择值改变的时候， onchange回调
            />
          </div>)
           :
          <SelectMultiple
            matchButtonWidth
            className="search-item filter-select-multiple"
            key={item.name + item.tableId}
            label={isEn ? (item?.label_en || item?.label) : item?.label}
            isFirst={item.isFirst}
            value={filterValues[item.name + item.tableId]}
            options={item.options?.map(opt =>({text: isEn ? opt?.text_en : opt?.text, value: opt?.value}))}
            // onOpen={async () => {
            //   if (item?.options && item?.options?.length > 0) return
            //   return fetchFilterOptions(item, index);
            // }}
            onChange={(value) => {
              filterValues[item.name + item.tableId] = value;
              onChange({ ...filterValues })
            }}
            // tips={loading && <LoadingTip />}
          />
      )
    }
  </div>)
}

export default ReportFilters
